import clsx from 'clsx'
import { FC } from 'react'
import logoFull from '@images/logo_full.png'
import logoMark from '@images/logo.png'

interface ILogo {
  className?: string
  // the size of the drawn logo (light theme)
  imageClassName?: string
  // the size of the words (dark theme)
  textClassName?: string
}

// The drawn logo's words are dark and vanish on a dark page: in the dark theme
// its vault mark stands beside the words as live text in the ink, as in the
// sidebar. The light theme keeps the drawing.
const Logo: FC<ILogo> = ({ className, imageClassName, textClassName }) => (
  <span data-logo className={clsx('flex items-center', className)}>
    <img
      src={logoFull}
      alt="Private Agreement"
      className={clsx('dark:hidden object-contain', imageClassName)}
    />
    <span className="hidden dark:flex items-center gap-2 h-full">
      <img src={logoMark} alt="" className="h-full w-auto object-contain" />
      <span
        className={clsx(
          'flex flex-col font-black leading-[1.05] whitespace-nowrap text-ink',
          textClassName,
        )}
      >
        Private
        <span className="text-ink-2">Agreement</span>
      </span>
    </span>
  </span>
)

export default Logo
